import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_RADIUS_PARSER_PASSWORD,
  RadiusParserPassword,
} from './radiusParserPassword.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getRadiusParserPassword(): AxiosPromise<ServerResponse<RadiusParserPassword>> {
  return http.get(`${API_PATH_RADIUS_PARSER_PASSWORD}`);
}

export function updateRadiusParserPassword(
  id: string,
  body: WithAuditDetails<RadiusParserPassword>,
): AxiosPromise<ServerResponse<RadiusParserPassword>> {

  return http.put(`${API_PATH_RADIUS_PARSER_PASSWORD}/${id}`, body);
}

export function deleteRadiusParserPassword(
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<void>> {
  // NOTE: it was needed to wrap the body in a data field because DELETE method behhaviour
  return http.delete(`${API_PATH_RADIUS_PARSER_PASSWORD}/${id}`, { data: body });
}

export function createRadiusParserPassword(
  body: WithAuditDetails<RadiusParserPassword>,
): AxiosPromise<ServerResponse<RadiusParserPassword>> {
  return http.post(`${API_PATH_RADIUS_PARSER_PASSWORD}`, body);
}
